// extracted by mini-css-extract-plugin
module.exports = {"btn":"CloseBtn_btn__Dk34n"};